import React from 'react';
import Header from './landing/Header';
import Footer from './landing/Footer';
import './Layout.css';
import { Outlet } from 'react-router-dom';

const Layout = () => {
  return (
    <div className="landing">
      <Header/>

      <main>
        <Outlet/>
      </main>

      <Footer/>
    </div>
  );
};

export default Layout;
